import { CURRENT, FAIL, GETALLUSERS, GETONEUSER, LOGIN, LOGOUT, REGISTER } from "../ActionTypes/AuthTypes"

// État initial SANS localStorage
const initialState = {
  user: null,
  token: null,
  isAuth: false,
  load: false,
  errors: [],
  users: [],
  upUser: null
}

const AuthReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REGISTER:
    case LOGIN:
      return {
        ...state,
        load: false,
        user: payload?.user || payload?.found || payload?.newUser || null,
        token: payload?.token || null,
        isAuth: !!(payload?.token),
        errors: []
      }

    case CURRENT:
      return {
        ...state,
        load: false,
        user: payload?.user || payload || null,
        isAuth: true
      }

    case FAIL:
      return {
        ...state,
        load: false,
        errors: payload || []
      }

    case LOGOUT:
      return initialState

    case GETALLUSERS:
      return {
        ...state,
        load: false,
        users: payload || []
      }

    case GETONEUSER:
      return {
        ...state,
        load: false,
        upUser: payload || null
      }

    default:
      return state
  }
}

export default AuthReducer